import { LOCAL_STORAGE } from '/Foundation/React/code/Utilities/ExtranetConstants';
import { safeGetItem, safeSetItem } from '/Foundation/React/code/Utilities/LocalStorage';

const MAX_RECENT_SEARCHES = 5;
const MIN_RECENT_LENGTH = 2;

const storageKey = (accountId) => `${LOCAL_STORAGE.RECENT_SEARCHES}.${accountId}`;

export function getRecent(accountId) {
  if (!accountId) return [];
  const stored = safeGetItem(storageKey(accountId), []);
  return Array.isArray(stored) ? stored.filter((q) => typeof q === 'string').slice(0, MAX_RECENT_SEARCHES) : [];
}

const write = (accountId, list) => {
  if (accountId) safeSetItem(storageKey(accountId), list);
  return list;
};

export function addRecent(accountId, query) {
  const current = getRecent(accountId);
  const trimmed = (query ?? '').trim();
  if (!accountId || trimmed.length < MIN_RECENT_LENGTH) return current;

  const lowered = trimmed.toLowerCase();
  const updated = [trimmed, ...current.filter((q) => q.toLowerCase() !== lowered)].slice(0, MAX_RECENT_SEARCHES);
  return write(accountId, updated);
}

export function removeRecent(accountId, query) {
  const lowered = query.toLowerCase();
  return write(
    accountId,
    getRecent(accountId).filter((q) => q.toLowerCase() !== lowered)
  );
}

export function clearRecent(accountId) {
  return write(accountId, []);
}
